Prism.languages.tap = {
  fail: /not ok[^#{\n\r]*/,
  pass: /ok[^#{\n\r]*/,
  pragma: /pragma [+-][a-z]+/,
  bailout: /bail out!.*/i,
  version: /TAP version \d+/i,
  plan: /\d+\.\.\d+(?: +#.*)?/,
  subtest: {
    pattern: /# Subtest(?:: .*)?/,
    greedy: !0
  },
  punctuation: /[{}]/,
  directive: /#.*/,
  yamlish: {
    pattern: /(^[^\S\r\n]*)---(?:\r\n?|\n)(?:.*(?:\r\n?|\n))*?[^\S\r\n]*\.\.\.$/m,
    lookbehind: !0,
    inside: Prism.languages.yaml,
    alias: "language-yaml"
  }
};